import script from "./Warranty.vue?vue&type=script&setup=true&lang=js"
export * from "./Warranty.vue?vue&type=script&setup=true&lang=js"

import "./Warranty.vue?vue&type=style&index=0&id=75ae3c50&lang=css"

const __exports__ = script;

export default __exports__